import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=ebec6310&"
import script from "./popup.vue?vue&type=script&lang=ts&"
export * from "./popup.vue?vue&type=script&lang=ts&"
import style0 from "./popup.vue?vue&type=style&index=0&id=ebec6310&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports